// import React, { Component, useEffect } from "react";
import React, { Component } from "react";
import { Col, Row, Container, Button, Modal, Input } from "reactstrap";
import OrderCard from "../../components/OrderCard";
import RequestManager from "../../singletons/RequestManager";
import DetailedOrderCard from "../../components/DetailedOrderCard";
import ConfirmPrintRoll from "../../components/DetailedOrderCard/ConfirmPrintRoll";
import ErrorTokenMiss from "../../components/ErrorTokenMiss/ErrorTokenMiss";
import ChromePrint from "../../components/ChromePrint/ChromePrint";
import SOSWaiter from "../../components/SOSWaiter/SOSWaiter";
import QRCodeScanner from "../../components/QRCodeScanner";

import {
  TIME_INTERVAL_ORDER,
  SDK_NGX_ASHWA,
  SDK_NGX_NIX,
  SDK_SUNMI_MINI_T1,
  SDK_SUNMI_PRO2,
  SDK_CHROME_ELECTRON,
  SDK_CHROME
} from "../../config/Constants";
import config from "../../config";
import moment from "moment";

import OrderStatusManager from "../../components/DetailedOrderCard/OrderStatusManager";
import {generateHeaders, generateHeaderswithBasicAuthToken, generateEpochTimestamp, generateSignature} from "../../utils/helper";
let requestManager = new RequestManager();
const orderStatusManager = new OrderStatusManager();

let player;

const styles = {
  newstyle: {
    backgroundColor: "red",
    display: "flex",
    color: "white",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 10,
  },
};

// // Use effect to add event listeners for user interaction
// useEffect(() => {
//   const events = ['click', 'keydown', 'mousemove', 'touchstart'];

//   events.forEach(event => {
//     document.addEventListener(event, enableSoundNotifications, { once: true });
//   });

//   return () => {
//     events.forEach(event => {
//       document.removeEventListener(event, enableSoundNotifications);
//     });
//   };
// }, [this.soundEnabled]);
export default class ActiveOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      printRollChange: "",
      soundPlayStatus: false,
      loginMode: null,
      isOpen: false,
      bussiness: null,
      isAppBasedPrint: true,
      isPrint: false,
      isShowArrived: false,
      tokenId: null,
      popUpOrderDetails: null,
      orderModalVisible: false,
      confirmModalVisible: false,
      qrCodeModalVisible: false,
      storeInformation: null,
      scanNewOrder: null,
      scanAcceptOrder: null,
      canScanQRCode: false,
      canStoreOpen: false,
      newOrderCount: 0,
      readyOrderCount: 0,
      playSound: false,
      tokenMissmatchModalVisible: false,
      tokenErrorMessage: "",
      barCodeGenerate: false,
      printSdkType: "",
      printRollCount: 0,
      chromePrintModalVisible: false,
      isSosApiCall: false,
      SOSWaiterModalVisible: false,
      SOSWaiters: null,
      storeName: "",
      showSOSRed: false,
      SOSForRegions: null,
      orderId: null,
      soundEnabled : false,
      canAutoPrintKot : false,
    };
  }

  
  
  componentDidMount() {
    let reloadActive = localStorage.getItem("reloadActive");
    if (reloadActive === null) {
      localStorage.setItem("reloadActive", "Y");
      window.location.reload();
    }

    this.getStoreDetails();
    // Peri changes for sound
    const events = ['click', 'keydown', 'mousemove', 'touchstart'];
    events.forEach(event => {
      document.addEventListener(event, this.enableSoundNotifications, { once: true });
    });
  }

  componentWillMount() {
    requestManager.setCheckActiveOrders(true);
  }

  componentWillUnmount() {
    requestManager.setCheckActiveOrders(false);

    clearInterval(this.getuserAvailedServicesInterval);
    clearInterval(this.fetchOrderInterval);
    // Peri changes for sound
    const events = ['click', 'keydown', 'mousemove', 'touchstart'];
    events.forEach(event => {
      document.removeEventListener(event, this.enableSoundNotifications);
    });
    
  }
// Peri changes for Sound
  enableSoundNotifications = () => {
    if (!this.state.soundEnabled) {
      
      this.setState({ soundEnabled: true });
      console.log('Sound notifications enabled.');
    }
  };

  getPrintRollChange = () => {
    let printRollChange = localStorage.getItem("printRollChange");
    if (printRollChange !== null) {
      this.setState({ printRollChange: printRollChange });
    }
  };
  toggleChromePrintModal = () => {
    this.setState({
      chromePrintModalVisible: !this.state.chromePrintModalVisible,
    });
  };
  toggleSOSWaiterModal = () => {
    this.setState({
      SOSWaiterModalVisible: !this.state.SOSWaiterModalVisible,
    });
  };

  requestNotificationPermission = () => {
    if ("Notification" in window) {
      if (Notification.permission === "granted") {
        return true;
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission(function (permission) {
          if (permission === "granted") {
            return true;
          } else {
            return false;
          }
        });
      } else {
        return false;
      }
    }
  };

  getStoreDetails = async () => {
    let params = {};
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getUserProfile",
      params
    );
    // console.log("getUserProfile", JSON.stringify(response));
    if (response.error) {
      // alert('Something went wrong. Please try again later.')
    } else {
      let res = response;
      if (res.data.userProfile.user.store === null) {
      } else {
        if (res.data.userProfile.user.store.printRollChange === null)
          localStorage.setItem("printRollChange", "NEW_ROLL");
        else {
          localStorage.setItem(
            "printRollChange",
            res.data.userProfile.user.store.printRollChange
          );
        }

        let loginMode = localStorage.getItem("loginMode");
        let storeInformation = JSON.parse(
          localStorage.getItem("storeInformation")
        );

        if (loginMode === "store") {
          let storeInfo = {
            user: storeInformation.user,
            store: res.data.userProfile.user.store,
            merchant: res.data.userProfile.user.merchant,
            concessionaire: res.data.userProfile.user.concessionaire,
            token: storeInformation.token,
          };

          localStorage.setItem("storeInformation", JSON.stringify(storeInfo));

          // if (
          //   res.data.userProfile.user.store.printSdkType &&
          //   res.data.userProfile.user.store.printSdkType === SDK_CHROME_ELECTRON
          // ) {
          //   let GNGPrinters = localStorage.getItem("GNGPrinters");

          //   if (GNGPrinters !== null) {
          //     try {
          //       let gngPrintersSelected = localStorage.getItem(
          //         "gngPrintersSelected"
          //       );
          //       if (gngPrintersSelected !== null) this.toggleChromePrintModal();
          //     } catch (e) {
          //       this.toggleChromePrintModal();
          //     }
          //   }
          // }

          //query isSosApiCall
          if (res.data.userProfile.user.store.isSosApiCall === true) {
            if (res.data.userProfile.user.store.region.id !== null) {
              this.getuserAvailedServicesInterval = setInterval(() => {
                this.getuserAvailedServices(
                  res.data.userProfile.user.store.region.id
                );
              }, TIME_INTERVAL_ORDER);

              this.getuserAvailedServices(
                res.data.userProfile.user.store.region.id
              );
            }
          }
        }
        let regionid = "";
        if (res.data.userProfile.user.store.region) {
          regionid = res.data.userProfile.user.store.region.id;
        }
        this.setState({
          SOSForRegions: regionid,
          storeName: res.data.userProfile.user.store.name,
          isSosApiCall: res.data.userProfile.user.store.isSosApiCall,
          isOpen: res.data.userProfile.user.store.isOpen,
          bussiness: res.data.userProfile.user.store.businessDomain.name,
          printRollChange: res.data.userProfile.user.store.printRollChange,
          printSdkType: res.data.userProfile.user.store.printSdkType,
          barCodeGenerate: res.data.userProfile.user.store.barCodeGenerate,
        });
        this.checkLoginMode();
        this.requestNotificationPermission();

        this.fetchOrderInterval = setInterval(() => {
          this.fetchOrders();
        }, TIME_INTERVAL_ORDER);

        this.fetchOrders();
      }
    }
  };

  getuserAvailedServices = async (forRegions) => {
    let params = {
      forRegions: forRegions,
    };
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getuserAvailedServices",
      params
    );
    // console.log("getuserAvailedServices", JSON.stringify(response));
    if (response.error) {
      // alert('Something went wrong. Please try again later.')
    } else {
      let SOSWaiters = response.data.userAvailedServices;

      this.setState({ SOSWaiters: SOSWaiters });
      if (SOSWaiters.edges.length > 0) {
        this.setState({ showSOSRed: true });
        try {
          this.notifiyNewOrdersUsingSoundAndNotificationSOS();
        } catch (e) {
          console.log("notifiyNewOrdersUsingSoundAndNotificationSOS", e);
        }
      } else {
        this.setState({ showSOSRed: false });
      }
    }
  };

  checkLoginMode = () => {
    let loginMode = localStorage.getItem("loginMode");
    if (loginMode === "concessionaire") {
      this.props.history.push("/ordersummary");
    } else {
      let storeInformation = JSON.parse(
        localStorage.getItem("storeInformation")
      );

      if (
        (storeInformation.store &&
          storeInformation.store.printSdkType &&
          storeInformation.store.printSdkType !== SDK_NGX_ASHWA) ||
        (storeInformation.store &&
          storeInformation.store.printSdkType &&
          storeInformation.store.printSdkType !== SDK_SUNMI_MINI_T1) ||
        (storeInformation.store &&
          storeInformation.store.printSdkType &&
          storeInformation.store.printSdkType !== SDK_SUNMI_PRO2)
      )
        player = document.getElementById("audio");

      this.setState({
        loginMode: loginMode,
        isPrint:
          storeInformation.store && storeInformation.store.isPrintEnabled,
        isAppBasedPrint:
          storeInformation.store && storeInformation.store.shouldPrintViaApp,
        isShowArrived:
          storeInformation.store && storeInformation.store.showArrived,
        storeInformation: storeInformation.store && storeInformation,
        canStoreOpen:
          storeInformation.store && storeInformation.store.canMarkOpen,
        canScanQRCode:
          storeInformation.store && storeInformation.store.canScanQRcode,
      });
    }
  };


  heartbeat = async () =>{
    try {
      let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
      let authToken = storeInformation.token;
      var vtimestamp = generateEpochTimestamp();
      let response = await fetch(
        config.getHost() + "/product/update_store_heartbeat/",
        {
          method: "POST",
          headers: {
            Authorization: `Token ${authToken}`,
            "Content-Type": "application/json",
            Timestamp: vtimestamp,
            Signature: generateSignature(vtimestamp, authToken)                
          },
          body: JSON.stringify({
            store_id: storeInformation.store && storeInformation.store.id,
            graphql:true
          }),
        }
      );

      console.log("Response", response);

      if (response.status === 200) {
      } else {
        console.log("res", response.status);
      }
    } catch (error) {
      console.log("error", error);
  }
};

  fetchOrders_old = async () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let params = {};
    let loginMode = localStorage.getItem("loginMode");

    if (loginMode === "concessionaire") {
      this.props.history.push("/ordersummary");
    } else {
      if (loginMode === "store") {
        params = {
          storeId: storeInformation.store && storeInformation.store.id,
          createdAt_Gte: moment().startOf("day").format(),
          createdAt_Lte: moment().format(),
        };
      } else {
        params = {
          merchantId: storeInformation.merchant && storeInformation.merchant.id,
          createdAt_Gte: moment().startOf("day").format(),
          createdAt_Lte: moment().format(),
        };
      }

      if (loginMode === "merchant") {
        let response = await requestManager.getResponseFromPredefinedQuery(
          "getOrders",
          params
        );

        if (response.error === null) {
          let newOrderCount = 0,
            readyOrderCount = 0;

          newOrderCount = response.data.newOrders.edges.length;
          readyOrderCount = response.data.acceptedOrders.edges.length;

          this.setState({
            orderData: response.data,
            newOrders: response.data.newOrders,
            orderHistory: response.data.orderHistory,
            acceptedOrders: response.data.acceptedOrders,
            approachingOrders: response.data.approachingOrders,
            arrivedOrders: response.data.arrivedOrders,
            newOrderCount: newOrderCount,
            readyOrderCount: readyOrderCount,
          });

          console.log("response active orders", JSON.stringify(response.data));
          try {
            this.notifiyNewOrdersUsingSoundAndNotification();
          } catch (e) {
            console.log("notifiyNewOrdersUsingSoundAndNotification", e);
          }
        } else {
          console.log("Connection to server failed.");
        }
      } else {
        // HERE showArrived KEY WILL DECIDE WHETHER IT IS KIOSK ORDERS OR NORMAL ORDERS
        if (
          storeInformation.store &&
          storeInformation.store.showArrived === true
        ) {
          let response = await requestManager.getResponseFromPredefinedQuery(
            "getOrders",
            params
          );

          if (response.error === null) {
            let newOrderCount = 0,
              readyOrderCount = 0;

            newOrderCount = response.data.newOrders.edges.length;
            readyOrderCount = response.data.acceptedOrders.edges.length;

            this.setState({
              orderData: response.data,
              newOrders: response.data.newOrders,
              orderHistory: response.data.orderHistory,
              acceptedOrders: response.data.acceptedOrders,
              approachingOrders: response.data.approachingOrders,
              arrivedOrders: response.data.arrivedOrders,
              newOrderCount: newOrderCount,
              readyOrderCount: readyOrderCount,
            });

            console.log(
              "response active orders",
              JSON.stringify(response.data)
            );

            try{
              console.log('this.newOrderCount line 427', newOrderCount);
              console.log('Notification line 427', Notification.permission);
              if (newOrderCount > 0){  
                console.log('this.newOrderCount-1', newOrderCount);
                new Notification(
                  // `New Order! Token number:${orderDetails.node.storeToken}`,
                  `New Order! `,
                  {
                    body:
                      "A new order has been received at your store. Please accept it.",
                    icon: require("../../assets/img/brand/highlighted-logo.png"),
                  }
                  
                );
                console.log('this.newOrderCount-2', newOrderCount);
                this.playSound();
              }
            }
            catch (e) {
              console.log("NotificationError", e);
              }

            try {
              this.notifiyNewOrdersUsingSoundAndNotification();
            } catch (e) {
              console.log("notifiyNewOrdersUsingSoundAndNotification", e);
            }
          } else {
            console.log("Connection to server failed.");
          }
        } else 
        
        {
          let response = await requestManager.getResponseFromPredefinedQuery(
            "getKioskOrders",
            params
          );
          console.log("getOrders getKioskOrders", JSON.stringify(response.data));
          if (response.error === null) {
            let obj = {
              edges: [],
            };

            let newOrderCount = 0,
              readyOrderCount = 0;

            newOrderCount = response.data.newOrders.edges.length;

            for (
              let i = 0;
              i < response.data.acceptedOrders.edges.length;
              i++
            ) {
              if (
                response.data.acceptedOrders.edges[i].node.status === "READY"
              ) {
                readyOrderCount = readyOrderCount + 1;
              }
            }

            this.setState({
              orderData: response.data,
              newOrders: response.data.newOrders,
              orderHistory: response.data.orderHistory,
              acceptedOrders: response.data.acceptedOrders,
              approachingOrders: obj,
              arrivedOrders: obj,
              newOrderCount: newOrderCount,
              readyOrderCount: readyOrderCount,
            });

            try{
              console.log('this.newOrderCount line 498', newOrderCount);
              console.log('Notification.permission line 498', Notification.permission);
              
              if (newOrderCount > 0){  
                console.log('this.newOrderCount-3', newOrderCount);
                new Notification(
                  // `New Order! Token number:${orderDetails.node.storeToken}`,
                  `New Order! `,
                  {
                    body:
                      "A new order has been received at your store. Please accept it.",
                    icon: require("../../assets/img/brand/highlighted-logo.png"),
                  }
                  
                );
                console.log('this.newOrderCount-4', newOrderCount);
                this.playSound();
              }
            }
            catch (e) {
              console.log("NotificationError", e);
              }

            try {
              this.notifiyNewOrdersUsingSoundAndNotification();
            } catch (e) {
              console.log("notifiyNewOrdersUsingSoundAndNotification", e);
              // alert(e)
            }
          } else {
            console.log("Connection to server failed.");
          }
        }
      }
    }
    // // Peri added to push notification and order sound for everytime a push order is there for every fetch
    // try{
    //   console.log('this.newOrderCount 533', this.newOrderCount);
    //   if (this.newOrderCount > 0){  
    //     console.log('this.newOrderCount-1', this.newOrderCount);
    //     console.log('Notification.permission-1', Notification.permission);
        
    //     new Notification(
    //       // `New Order! Token number:${orderDetails.node.storeToken}`,
    //       `New Order! `,
    //       {
    //         body:
    //           "A new order has been received at your store. Please accept it.",
    //         icon: require("../../assets/img/brand/highlighted-logo.png"),
    //       }
          
    //     );
    //     console.log('this.newOrderCount-2', this.newOrderCount);
    //     // this.playSound();
    //   }
    // }
    // catch (e) {
    //   console.log("NotificationError", e);
    //   }
    
      // this.playSound();
    try {
      
      this.heartbeat();
    } 
    catch (e) {
    console.log("heartbeaterror", e);
    }
  };

  fetchOrders = async () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let params = {};
    let loginMode = localStorage.getItem("loginMode");
  
    if (loginMode === "concessionaire") {
      this.props.history.push("/ordersummary");
    } else {
      if (loginMode === "store") {
        params = {
          storeId: storeInformation.store && storeInformation.store.id,
          createdAt_Gte: moment().startOf("day").format(),
          createdAt_Lte: moment().format(),
        };
      } else {
        params = {
          merchantId: storeInformation.merchant && storeInformation.merchant.id,
          createdAt_Gte: moment().startOf("day").format(),
          createdAt_Lte: moment().format(),
        };
      }
  
      if (loginMode === "merchant") {
        let response = await requestManager.getResponseFromPredefinedQuery(
          "getOrders",
          params
        );
  
        if (response.error === null) {
          let newOrderCount = 0,
            readyOrderCount = 0;
  
          newOrderCount = response.data.newOrders.edges.length;
          readyOrderCount = response.data.acceptedOrders.edges.length;
  
          this.setState({
            orderData: response.data,
            newOrders: response.data.newOrders,
            orderHistory: response.data.orderHistory,
            acceptedOrders: response.data.acceptedOrders,
            approachingOrders: response.data.approachingOrders,
            arrivedOrders: response.data.arrivedOrders,
            newOrderCount: newOrderCount,
            readyOrderCount: readyOrderCount,
          });
  
          console.log("response active orders", JSON.stringify(response.data));
          try {
            this.notifiyNewOrdersUsingSoundAndNotification();
          } catch (e) {
            console.log("notifiyNewOrdersUsingSoundAndNotification", e);
          }
        } else {
          console.log("Connection to server failed.");
        }
      } else {
        // ShowArrived key will decide whether it is kiosk orders or normal orders
        if (
          storeInformation.store &&
          storeInformation.store.showArrived === true
        ) {
          let response = await requestManager.getResponseFromPredefinedQuery(
            "getOrders",
            params
          );
  
          if (response.error === null) {
            let newOrderCount = 0,
              readyOrderCount = 0;
  
            newOrderCount = response.data.newOrders.edges.length;
            readyOrderCount = response.data.acceptedOrders.edges.length;
  
            this.setState({
              orderData: response.data,
              newOrders: response.data.newOrders,
              orderHistory: response.data.orderHistory,
              acceptedOrders: response.data.acceptedOrders,
              approachingOrders: response.data.approachingOrders,
              arrivedOrders: response.data.arrivedOrders,
              newOrderCount: newOrderCount,
              readyOrderCount: readyOrderCount,
            });
  
            console.log(
              "response active orders",
              JSON.stringify(response.data)
            );
  
            try {
              console.log('this.newOrderCount line 427', newOrderCount);
              console.log('Notification line 427', Notification.permission);
              if (newOrderCount > 0) {  
                console.log('this.newOrderCount-1', newOrderCount);
                new Notification(
                  `New Order! `,
                  {
                    body: "A new order has been received at your store. Please accept it.",
                    icon: require("../../assets/img/brand/highlighted-logo.png"),
                  }
                );
                console.log('this.newOrderCount-2', newOrderCount);
                this.playSound();
              }
            } catch (e) {
              console.log("NotificationError", e);
            }
  
            try {
              this.notifiyNewOrdersUsingSoundAndNotification();
            } catch (e) {
              console.log("notifiyNewOrdersUsingSoundAndNotification", e);
            }
          } else {
            console.log("Connection to server failed.");
          }
        } else {
          let newOrderCount = 0;
          let readyOrderCount = 0;
  
          try {
            let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
            let authToken = storeInformation.token;
            var vtimestamp = generateEpochTimestamp();
            let response = await fetch(
              config.getHost() + "/order/getorders/",
              {
                method: "POST",
                headers: {
                  Authorization: `Token ${authToken}`,
                  "Content-Type": "application/json",
                  Timestamp: vtimestamp,
                  Signature: generateSignature(vtimestamp, authToken),
                },
                body: JSON.stringify({
                  store_id: storeInformation.store && storeInformation.store.id,
                  graphql: true,
                }),
              }
            );
  
            console.log("Response", response);
  
            if (response.status === 200) {
              let result = await response.json();
              // console.log("Response", response);
              if (result.SUCCESS) {
                let data = result.data;
                // console.log("Order Count:", data);
                  newOrderCount = 0,
                  readyOrderCount = 0;
                  
                newOrderCount = data.newOrders.edges.length;
                
                for (let i = 0; i < data.acceptedOrders.edges.length; i++) {
                
                  if (data.acceptedOrders.edges[i].node.status === "READY") {
                
                    readyOrderCount = readyOrderCount + 1;
                  }
                }
                
                let obj = { edges: [] };
                var v_canAutoPrintKot = false;

                if (data && data.store && data.store.node && data.store.node.canAutoPrintKot !== undefined) {
                  v_canAutoPrintKot = data.store.node.canAutoPrintKot;
                  
                }
                this.setState({
                  canAutoPrintKot: v_canAutoPrintKot,
                  orderData: data,
                  newOrders: data.newOrders,
                  // orderHistory: data.orderHistory,
                  acceptedOrders: data.acceptedOrders,
                  // approachingOrders: obj,
                  // arrivedOrders: obj,
                  newOrderCount: newOrderCount,
                  readyOrderCount: readyOrderCount,
                });
                
              }
            } else {
              console.log("res", response.status);
            }
          } catch (error) {
            console.log("error", error);
          }
  // Peri moving notification and sound to global notification  
          try {
            // console.log('this.newOrderCount line 498', newOrderCount);
            console.log('Notification.permission line 498', Notification.permission);
  
            if (newOrderCount > 0) {
              console.log('this.newOrderCount-3', newOrderCount);
              // try {
              // this.notifiyNewOrdersUsingSoundAndNotification();
              // } catch (e) {
              //   console.log("notifiyNewOrdersUsingSoundAndNotification", e);
              // }
              this.handle_auto_accept_auto_print()
              // new Notification(
              //   `New Order! `,
              //   {
              //     body: "A new order has been received at your store. Please accept it.",
              //     icon: require("../../assets/img/brand/highlighted-logo.png"),
              //   }
              // );
              // // console.log('this.newOrderCount-4', newOrderCount);
              // this.playSound();
            }
          } catch (e) {
            console.log("NotificationError", e);
          }
  
          // try {
          //   this.notifiyNewOrdersUsingSoundAndNotification();
          // } catch (e) {
          //   console.log("notifiyNewOrdersUsingSoundAndNotification", e);
          // }
        }
      }
    }
  
    try {
      this.heartbeat();
    } catch (e) {
      console.log("heartbeaterror", e);
    }
  };
  

  notifiyNewOrdersUsingSoundAndNotificationSOS = () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let storageData = localStorage.getItem("attendedSOSOrders");

    let attendedSOSOrders;
    if (storageData === null) {
      attendedSOSOrders = {
        newOrders: [],
      };
    } else {
      attendedSOSOrders = JSON.parse(storageData);
    }

    let newOrders = this.state.SOSWaiters.edges.map((order) => order.node.id);
    let newSoundOrders = newOrders.filter((order) => {
      return attendedSOSOrders.newOrders.indexOf(order) <= -1;
    });

    if (newSoundOrders.length > 0) {
      if (
        (storeInformation.store &&
          storeInformation.store.printSdkType &&
          storeInformation.store.printSdkType === SDK_NGX_ASHWA) ||
        (storeInformation.store &&
          storeInformation.store.printSdkType &&
          storeInformation.store.printSdkType === SDK_SUNMI_MINI_T1) ||
        (storeInformation.store &&
          storeInformation.store.printSdkType &&
          storeInformation.store.printSdkType === SDK_SUNMI_PRO2)
      ) {
        let getSound = localStorage.getItem("sound");
        if (getSound !== null) this.fromAndroid("play" + getSound);
        else this.fromAndroid("playbell");
      } else {
        // for delhi module
        this.playSound();
      }

      localStorage.setItem(
        "attendedSOSOrders",
        JSON.stringify({
          newOrders: attendedSOSOrders.newOrders.concat(newSoundOrders),
        })
      );
    }
  };

  notifiyNewOrdersUsingSoundAndNotification = () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let storageData = localStorage.getItem("attendedOrders");

    let attendedOrders;
    if (storageData === null) {
      attendedOrders = {
        newOrders: [],
        acceptedOrders: [],
        arrivedOrders: [],
        approachingOrders: [],
      };
    } else {
      attendedOrders = JSON.parse(storageData);
    }

    let newOrders = this.state.newOrders.edges.map(
      (order) => order.node.orderId
    );
    let newSoundOrders = newOrders.filter((order) => {
      return attendedOrders.newOrders.indexOf(order) <= -1;
    });

    let approachingOrders = this.state.approachingOrders.edges.map(
      (order) => order.node.orderId
    );
    let approachingSoundOrders = approachingOrders.filter((order) => {
      return attendedOrders.approachingOrders.indexOf(order) <= -1;
    });

    let arrivedOrders = this.state.arrivedOrders.edges.map(
      (order) => order.node.orderId
    );
    let arrivedSoundOrders = arrivedOrders.filter((order) => {
      return attendedOrders.arrivedOrders.indexOf(order) <= -1;
    });

    // store- multiple prints
    if (
      storeInformation.store &&
      storeInformation.store.isMultiplePrintEnabled &&
      storeInformation.store.isMultiplePrintEnabled === true
    ) {
      let printedOrders = localStorage.getItem("printedOrders");
      let accepted = this.state.acceptedOrders.edges;

      if (printedOrders === null) {
        if (accepted.length === 0) {
          localStorage.setItem(
            "printedOrders",
            JSON.stringify({
              orders: [],
            })
          );
        } else {
          let orders = [];
          for (let i = 0; i < accepted.length; i++) {
            orders.push(accepted[i].node.orderId);
          }

          localStorage.setItem(
            "printedOrders",
            JSON.stringify({
              orders: orders,
            })
          );
        }
      } else {
        let print = JSON.parse(printedOrders);
        for (let i = 0; i < accepted.length; i++) {
          let check = true;
          for (let j = 0; j < print.orders.length; j++) {
            if (accepted[i].node.orderId === print.orders[j]) {
              check = false;
              break;
            }
          }
          if (check) {
            this.fromAndroid("stop");
            console.log('debug-autoprint-1')
            this.fetchOrderDetails(accepted[i].node.orderId);
          }
        }

        // console.log("printed orders", print.orders);
      }
    }

    if (
      newSoundOrders.length > 0 ||
      approachingSoundOrders.length > 0 ||
      arrivedSoundOrders.length > 0
    ) {
      try {
        newSoundOrders.forEach((order) => {
          let orderDetails = this.state.newOrders.edges.find((orderDetails) => {
            return (orderDetails.node.orderId = order);
          });

          // if ("Notifcation" in window) {
          
          if (Notification.permission === "granted") {
          // if (1===1) {  
            new Notification(
              // `New Order! Token number:${orderDetails.node.storeToken}`,
              `New Order! `,
              {
                body:
                  "A new order has been received at your store. Please accept it.",
                icon: require("../../assets/img/brand/highlighted-logo.png"),
              }
            );
          }
          // }
        });

        arrivedSoundOrders.forEach((order) => {
          let orderDetails = this.state.arrivedOrders.edges.find(
            (orderDetails) => {
              return (orderDetails.node.orderId = order);
            }
          );
          // if ("Notification" in window) {
          if (Notification.permission === "granted") {
            new Notification(
              `Customer Arrived! Token number:${orderDetails.node.storeToken}`,
              {
                body:
                  "Customer has arrived at your store. Please step out and deliver order.",
                icon: require("../../assets/img/brand/highlighted-logo.png"),
              }
            );
          }
          // }
        });
      } catch (e) {
        console.log("err", JSON.stringify(e));
      }

      if (
        (storeInformation.store &&
          storeInformation.store.printSdkType &&
          storeInformation.store.printSdkType === SDK_NGX_ASHWA) ||
        (storeInformation.store &&
          storeInformation.store.printSdkType &&
          storeInformation.store.printSdkType === SDK_SUNMI_MINI_T1) ||
        (storeInformation.store &&
          storeInformation.store.printSdkType &&
          storeInformation.store.printSdkType === SDK_SUNMI_PRO2)
      ) {
        let getSound = localStorage.getItem("sound");
        if (getSound !== null) {
          this.fromAndroid("play" + getSound);
        } else {
          this.fromAndroid("playbell");
        }
      } else {
        // for delhi module
        this.playSound();
      }
      console.log('AUTO PRINT -1')
      const canAutoPrintKot = this.state.canAutoPrintKot;
        // storeInformation &&
        // storeInformation.store &&
        // storeInformation.store.canAutoPrintKot;
    
      if (canAutoPrintKot) {
      
        let newOrder = this.state.newOrders.edges;

        for (let i = 0; i < newOrder.length; i++) {
          console.log("newOrders1", JSON.stringify(newOrder));
          if (newOrder[i].node.status === "PUSHED") {
            console.log("newOrders2", newOrder[i].node.status);
            console.log('AUTO PRINT -2')
            this.getKOTDetails(newOrder[i].node.id, newOrder[i].node.orderId);
          }
        }
      }
      localStorage.setItem(
        "attendedOrders",
        JSON.stringify({
          newOrders: attendedOrders.newOrders.concat(newSoundOrders),
          approachingOrders: attendedOrders.approachingOrders.concat(
            approachingSoundOrders
          ),
          arrivedOrders: attendedOrders.arrivedOrders.concat(
            arrivedSoundOrders
          ),
        })
      );
    }
  };

  fetchOrderDetailsAutoPrint = async (id, orderID, kot) => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    console.log('fetchOrderDetailsAutoPrint-1')
   
   let oupdate_response = await orderStatusManager.updateOrderStatus(
     id,
      "ACCEPTED",
      0
    );
   console.log('fetchOrderDetailsAutoPrint-2')
    if (
          storeInformation.store.printSdkType === SDK_NGX_ASHWA ||
          storeInformation.store.printSdkType === SDK_SUNMI_PRO2 ||
          storeInformation.store.printSdkType === SDK_SUNMI_MINI_T1 ||
          storeInformation.store.printSdkType === SDK_NGX_NIX ||
          storeInformation.store.printSdkType === SDK_CHROME_ELECTRON
        
        ) {

        this.printRest(kot)
        console.log('fetchOrderDetailsAutoPrint-3')
        }
     this.fetchOrders();   
    // let requestManager = new RequestManager();

    // let params = {
    //   orderId: orderID,
    // };

    // let printedOrders = localStorage.getItem("printedOrders");
    // let print = JSON.parse(printedOrders);
    // localStorage.setItem(
    //   "printedOrders",
    //   JSON.stringify({
    //     orders: print.orders.concat(orderID),
    //   })
    // );
    
    // let response = await requestManager.getResponseFromPredefinedQuery(
    //   "getOrderDetails",
    //   params
    // );

    // if (response.error === null) {
    //   let orderDetails = response.data.orderDetails.edges[0];
    //   console.log('fetchOrderDetailsAutoPrint-1')
    //   this.updateOrderStatus("ACCEPTED", orderDetails, kot);
    //    console.log('fetchOrderDetailsAutoPrint-2')
    // } else {
    //   alert("Something went wrong try again.");
    //   console.log("Connection to server failed.");
    // }
  };

  fetchOrderDetails = async (orderID) => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));

    let requestManager = new RequestManager();

    let params = {
      orderId: orderID,
    };

    let printedOrders = localStorage.getItem("printedOrders");
    let print = JSON.parse(printedOrders);
    localStorage.setItem(
      "printedOrders",
      JSON.stringify({
        orders: print.orders.concat(orderID),
      })
    );

    let response = await requestManager.getResponseFromPredefinedQuery(
      "getOrderDetails",
      params
    );

    if (response.error === null) {
      let orderDetails = response.data.orderDetails.edges[0];

      if (response.data.orderDetails.edges.length > 0) {
        if (
          (storeInformation.store.printSdkType &&
            storeInformation.store.printSdkType === SDK_NGX_ASHWA) ||
          (storeInformation.store.printSdkType &&
            storeInformation.store.printSdkType === SDK_SUNMI_MINI_T1) ||
          (storeInformation.store.printSdkType &&
            storeInformation.store.printSdkType === SDK_SUNMI_PRO2) ||
          (storeInformation.store.printSdkType &&
            storeInformation.store.printSdkType === SDK_NGX_NIX)
        ) {
          let order = orderDetails;
          if (
            storeInformation.store &&
            storeInformation.store.barCodeGenerate === true
          ) {
            let obj = {
              BarCodeGenerate: "Y",
            };
            order.BarCodeGenerate = obj;
          } else {
            let obj = {
              BarCodeGenerate: "N",
            };
            order.BarCodeGenerate = obj;
          }

          if (
            (storeInformation.store &&
              storeInformation.store.printSdkType &&
              storeInformation.store.printSdkType === SDK_NGX_ASHWA) ||
            (storeInformation.store &&
              storeInformation.store.printSdkType &&
              storeInformation.store.printSdkType === SDK_SUNMI_MINI_T1) ||
            (storeInformation.store &&
              storeInformation.store.printSdkType &&
              storeInformation.store.printSdkType === SDK_SUNMI_PRO2)
          ) {
            this.fromAndroid(order);
          }
        }
      }
    } else {
      alert("Something went wrong try again.");
      console.log("Connection to server failed.");
    }
  };

  /**
   * Plays sound based on the selected ring file
   */
  playSound = () => {
    if (player !== null) {
      if (player.paused === true) {
        let requestManager = new RequestManager();
        let sound = requestManager.getSoundFile();
        console.log("sound activeorder" + sound);
        player.src = require("../../assets/sounds/" + sound + ".mp3");
        player.load();
        player.play();
      }
    }
  };

  toggleConfirmPrintRollModal = () => {
    this.setState({
      confirmModalVisible: !this.state.confirmModalVisible,
    });
  };
  toggleErrorTokenMissModal = (text) => {
    this.setState({
      tokenMissmatchModalVisible: !this.state.tokenMissmatchModalVisible,
      tokenErrorMessage: text,
    });
  };
  toggleModal = () => {
    this.setState({
      orderModalVisible: !this.state.orderModalVisible,
    });
    this.getPrintRollChange();
  };
  toggleQRCodeScannerModal = () => {
    this.setState({
      qrCodeModalVisible: !this.state.qrCodeModalVisible,
    });
  };
  fromAndroid = (data) => {
    if (window.totDevice) {
      window.totDevice.postMessage(JSON.stringify(data));
    }
  };
  cardSelected = () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    try {
      if (
        (storeInformation.store &&
          storeInformation.store.printSdkType &&
          storeInformation.store.printSdkType === SDK_NGX_ASHWA) ||
        (storeInformation.store &&
          storeInformation.store.printSdkType &&
          storeInformation.store.printSdkType === SDK_SUNMI_MINI_T1) ||
        (storeInformation.store &&
          storeInformation.store.printSdkType &&
          storeInformation.store.printSdkType === SDK_SUNMI_PRO2)
      ) {
        this.fromAndroid("stop");
      } else {
        if (player !== null) player.pause();
      }
    } catch (e) {
      console.log("soundPlayStatus", JSON.stringify(e));
    }
    console.log("soundPlayStatus", "pause");
  };

  toggleStoreStatus = async () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));

    if (this.state.loginMode === "store") {
      let input = {
        input: {
          id: storeInformation.store.id,
          isOpen: this.state.isOpen,
          printRollChange: "NEW_ROLL",
        },
      };

      let response = await requestManager.getResponseFromPredefinedQuery(
        "updateStoreStatus",
        input
      );

      if (response.error === null) {
        localStorage.setItem("printRollChange", "");
        this.setState({ printRollChange: "" });
      } else {
        alert(
          "Unable to update Store Status. Please check your internet connection."
        );
      }
    }
  };
  handleTokenIdChange = (event) => {
    this.setState({ tokenId: event.target.value });
  };
  tokenSearch = () => {
    if (this.state.tokenId === null) {
      this.toggleErrorTokenMissModal("Enter atleast one character.");
    } else {
      let check = false;
      for (let i = 0; i < this.state.newOrders.edges.length; i++) {
        if (
          JSON.stringify(this.state.newOrders.edges[i].node.storeToken) ===
          this.state.tokenId
        ) {
          check = true;
          this.setState({
            orderModalVisible: true,
            popUpOrderDetails: this.state.newOrders.edges[i],
          });
          break;
        }
      }
      if (check === false) {
        for (let i = 0; i < this.state.acceptedOrders.edges.length; i++) {
          if (
            JSON.stringify(
              this.state.acceptedOrders.edges[i].node.storeToken
            ) === this.state.tokenId
          ) {
            check = true;
            this.setState({
              orderModalVisible: true,
              popUpOrderDetails: this.state.acceptedOrders.edges[i],
            });
            break;
          }
        }
      }
      if (check === false) {
        for (let i = 0; i < this.state.orderHistory.edges.length; i++) {
          if (
            JSON.stringify(this.state.orderHistory.edges[i].node.storeToken) ===
            this.state.tokenId
          ) {
            check = true;
            this.setState({
              orderModalVisible: true,
              popUpOrderDetails: this.state.orderHistory.edges[i],
            });
            break;
          }
        }
      }
      if (check === false) {
        this.toggleErrorTokenMissModal("Token number is not matching.");
      }
    }
  };

  handleOrderIdChange = (event) => {
    this.setState({ orderId: event.target.value });
  };

  handle_auto_accept_auto_print(){
     let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));

       console.log('AUTO PRINT -1')
      
       const canAutoPrintKot = this.state.canAutoPrintKot;
        // storeInformation &&
        // storeInformation.store &&
        // storeInformation.store.canAutoPrintKot;
        
      if (canAutoPrintKot) {
      
        let newOrder = this.state.newOrders.edges;

        for (let i = 0; i < newOrder.length; i++) {
          console.log("newOrders1", JSON.stringify(newOrder));
          if (newOrder[i].node.status === "PUSHED") {
            console.log("newOrders2", newOrder[i].node.status);
            console.log('AUTO PRINT -2', newOrder[i].node.id)
            this.getKOTDetails(newOrder[i].node.id, newOrder[i].node.orderId);
          }
        }
      }
 
  }
  // auto KOT Print

    printRest = async (message) => {
      try {
        var jsonKOTBody = "";
       // const chromePrintersObject = JSON.parse(this.state.chromePrinters);
        const chromePrintersObject = typeof this.state.chromePrinters === "string" 
        ? JSON.parse(this.state.chromePrinters)
        : this.state.chromePrinters;
        if( this.state.forcePrinterSelection && chromePrintersObject.KOTPRINTER && (Array.isArray(chromePrintersObject.KOTPRINTER)) && chromePrintersObject.KOTPRINTER.length > 0)
        { 
          if(chromePrintersObject.pageSize){
  
          jsonKOTBody = JSON.stringify({
            gngprint: message,
            KOTPRINTER: chromePrintersObject.KOTPRINTER,
            pageSize: chromePrintersObject.pageSize
          })
        }else{
          jsonKOTBody = JSON.stringify({
            gngprint: message,
            KOTPRINTER: chromePrintersObject.KOTPRINTER
          })
        }
        }
        else if(this.state.forcePrinterSelection && chromePrintersObject.INVOICEPRINTER && (Array.isArray(chromePrintersObject.INVOICEPRINTER)) && chromePrintersObject.INVOICEPRINTER.length > 0)
        {
          if(chromePrintersObject.pageSize){
          jsonKOTBody = JSON.stringify({
            gngprint: message,
            KOTPRINTER: chromePrintersObject.INVOICEPRINTER,
            pageSize: chromePrintersObject.pageSize
          })
        }
        else{
          jsonKOTBody = JSON.stringify({
            gngprint: message,
            KOTPRINTER: chromePrintersObject.INVOICEPRINTER
          })
        }
        }
        else
        {
          jsonKOTBody = JSON.stringify({
            gngprint: message
          })
        }
        console.log("Json KOT body", jsonKOTBody);
        
        var vtimestamp = generateEpochTimestamp();
        let response = await fetch(
          config.getPrinter(),
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body:jsonKOTBody
            // body: JSON.stringify({
            //   gngprint: message
              
            // }),
          }
        );
  
        console.log("peri kot print", response);
  
        if (response.status !== 200) {
          if (response.status === 801){
            alert("printer Issue, Retry Print");  
          }
          else{
            alert("Printer Not Avaiable");
          }
        }
      } catch (error) {
        console.log("error", error);
        alert("Printer Not Avaiable");
      }
    };
  
    printInvoiceRest = async (message) => {
      try {
        var jsonInvoiceBody = "";
        
       // const chromePrintersObject = JSON.parse(this.state.chromePrinters);
        const chromePrintersObject = typeof this.state.chromePrinters === "string"
      ? JSON.parse(this.state.chromePrinters)
      : this.state.chromePrinters;
        
            // Check if pageSize exists
      
        if(this.state.forcePrinterSelection && chromePrintersObject.INVOICEPRINTER && (Array.isArray(chromePrintersObject.INVOICEPRINTER)) && chromePrintersObject.INVOICEPRINTER.length > 0)
        {
          if(chromePrintersObject.pageSize){
            jsonInvoiceBody = JSON.stringify({
              gnginvoiceprint: message,
              INVOICEPRINTER: chromePrintersObject.INVOICEPRINTER,
              pageSize: chromePrintersObject.pageSize
            })
          }else{
          jsonInvoiceBody = JSON.stringify({
            gnginvoiceprint: message,
            INVOICEPRINTER: chromePrintersObject.INVOICEPRINTER
          })
        }
        }
        else if(this.state.forcePrinterSelection && chromePrintersObject.KOTPRINTER && (Array.isArray(chromePrintersObject.KOTPRINTER)) && chromePrintersObject.KOTPRINTER.length > 0)
          {
            if(chromePrintersObject.pageSize){
            jsonInvoiceBody = JSON.stringify({
              gnginvoiceprint: message,
              INNOVICEPRINTER: chromePrintersObject.KOTPRINTER,
              pageSize: chromePrintersObject.pageSize
            })
          }else{
            jsonInvoiceBody = JSON.stringify({
              gnginvoiceprint: message,
              INNOVICEPRINTER: chromePrintersObject.KOTPRINTER
            })
          }
          }
          else
          {
            jsonInvoiceBody = JSON.stringify({
              gnginvoiceprint: message
            })
          }
        console.log("Json Invoice body", jsonInvoiceBody);
        
        var vtimestamp = generateEpochTimestamp();
        let response = await fetch(
          config.getPrinter(),
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body:jsonInvoiceBody
            // body: JSON.stringify({
            //   gnginvoiceprint: message
              
            // }),
            
          }
        );
  
        console.log("print", response);
  
        if (response.status !== 200) {
          if (response.status === 801){
            alert("printer Issue, Retry Print");  
          }
          else{
            alert("Printer Not Avaiable");
          }
        }
      } catch (error) {
        console.log("error", error);
        alert("Printer Not Avaiable");
      }
    };
    getInvoiceDetails = async () => {
      let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
      let authToken = storeInformation.token;
      let gngPrinterFontSize = localStorage.getItem("gngPrinterFontSize");
  
      let fontSize = 14;
      if (gngPrinterFontSize !== null) {
        fontSize = gngPrinterFontSize;
      }
  
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Token " + authToken);
      console.log(
        "params",
        JSON.stringify({
          checkout_id: this.props.order.node.cart.checkout.id,
          font_size: fontSize,
          print_type: "INVOICE",
        })
      );
      // region_name
      try {
        var vtimestamp = generateEpochTimestamp();
        let response = await fetch(
          config.getHost() + "/product/get_invoice_details_html_string/",
          {
            method: "POST",
            headers: {
              Authorization: `Token ${authToken}`,
              "Content-Type": "application/json",
              Timestamp: vtimestamp,
              Signature: generateSignature(vtimestamp, authToken)               
            },
            body: JSON.stringify({
              checkout_id: this.props.order.node.cart.checkout.id,
              font_size: fontSize,
              print_type: "INVOICE",
            }),
          }
        );
  
        console.log("INVOICE", response);
  
        if (response.status === 200) {
          let json = await response.json();
          let res = json.result;
          console.log("INVOICE", res);
          let invoice = "";
          if (res && res.length > 0) {
            invoice = `${res[0]}`;
          }
  
          this.setState({ invoicePrintFun: invoice });
        }
      } catch (error) {
        console.log("error", error);
      }
    };
  
    getOrderSummary = async () => {
      let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
      let authToken = storeInformation.token;
    
    
      // region_name
      try {
        var vtimestamp = generateEpochTimestamp();
        let response = await fetch(
          config.getHost() + "/order/adlgetordersumary/",
          {
            method: "POST",
            headers: {
              Authorization: `Token ${authToken}`,
              "Content-Type": "application/json",
              Timestamp: vtimestamp,
              Signature: generateSignature(vtimestamp, authToken)               
            },
            body: JSON.stringify({
              order_id: this.props.order.node.orderId
            }),
          }
        );
  
       
  
        if (response.status === 200) {
          let json = await response.json();
          let res = json.order_summary;
          console.log("INVOICE", res);
          let order_summary = "";
          if (res ) {
            order_summary = `${res}`;
          }
  
          this.setState({ order_summary: order_summary });
        }
      } catch (error) {
        console.log("error", error);
      }
    };
  
   

  // auto KOT print
  orderIDSearch = () => {
    if (!this.state.orderId) {
      this.toggleErrorTokenMissModal("Enter at least one character.");
    } else {
      const orderIdLowerCase = this.state.orderId.toLowerCase();
      let check = false;
  
      // Search in new orders
      for (let i = 0; i < this.state.newOrders.edges.length; i++) {
        const order = this.state.newOrders.edges[i].node;
        if (order.orderId.toLowerCase() === orderIdLowerCase) {
          check = true;
          this.setState({
            orderModalVisible: true,
            popUpOrderDetails: this.state.newOrders.edges[i],
          });
          break;
        }
      }
  
      // If not found in new orders, search in accepted orders
      if (!check) {
        for (let i = 0; i < this.state.acceptedOrders.edges.length; i++) {
          const order = this.state.acceptedOrders.edges[i].node;
          if (order.orderId.toLowerCase() === orderIdLowerCase) {
            check = true;
            this.setState({
              orderModalVisible: true,
              popUpOrderDetails: this.state.acceptedOrders.edges[i],
            });
            break;
          }
        }
      }
  
      // If not found in accepted orders, search in order history
      if (!check) {
        for (let i = 0; i < this.state.orderHistory.edges.length; i++) {
          const order = this.state.orderHistory.edges[i].node;
          if (order.orderId.toLowerCase() === orderIdLowerCase) {
            check = true;
            this.setState({
              orderModalVisible: true,
              popUpOrderDetails: this.state.orderHistory.edges[i],
            });
            break;
          }
        }
      }
  
      if (!check) {
        this.toggleErrorTokenMissModal("Order ID not found");
      }
    }
  };
  render() {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    return (
      <Container fluid style={{ padding: 0, margin: 0 }}>
        <Modal
          size="lg"
          isOpen={this.state.chromePrintModalVisible}
          toggle={this.toggleChromePrintModal}
        >
          <ChromePrint goBack={this.toggleChromePrintModal} />
        </Modal>

        <Modal
          size="lg"
          isOpen={this.state.SOSWaiterModalVisible}
          toggle={this.toggleSOSWaiterModal}
        >
          <SOSWaiter
            goBack={this.toggleSOSWaiterModal}
            SOSWaiters={this.state.SOSWaiters}
          />
        </Modal>
        {(storeInformation.store &&
          storeInformation.store.printSdkType &&
          storeInformation.store.printSdkType === SDK_NGX_ASHWA) ||
        (storeInformation.store &&
          storeInformation.store.printSdkType &&
          storeInformation.store.printSdkType === SDK_SUNMI_MINI_T1) ||
        (storeInformation.store &&
          storeInformation.store.printSdkType &&
          storeInformation.store.printSdkType === SDK_SUNMI_PRO2) ? null : (
          <iframe
            id="audio"
            volume={0}
            title="s"
            hidden
            src={require("../../assets/sounds/mute.mp3")}
          ></iframe>
        )}

        {this.state.isSosApiCall === true ? (
          <Row
            style={{
              display: "flex",
              flex: 1,
              alignItems: "center",

              backgroundColor: this.state.showSOSRed === true ? "red" : "white",
              justifyContent: "space-between",
            }}
          >
            <p></p>
            <p
              style={{
                paddingTop: 10,
              }}
            >
              {this.state.storeName}
            </p>
            <Button
              color={"primary"}
              onClick={() => {
                this.cardSelected();
                this.toggleSOSWaiterModal();
              }}
            >
              {"Call Waiters"}
            </Button>
            <p style={{}}></p>
          </Row>
        ) : (
          <Row
            style={{
              display: "flex",
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p style={{ alignContent: "center", paddingTop: 10 }}>
              {this.state.storeName}
            </p>
          </Row>
        )}
        {this.state.printRollChange === "CHANGE_SOON" ? (
          <Row
            className="border-bottom"
            style={{
              backgroundColor: "yellow",
              display: "flex",
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <h5 style={{ padding: 10 }}> Print roll change soon </h5>
          </Row>
        ) : null}
        {this.state.printRollChange === "CHANGE_NOW" ? (
          <Row className="border-bottom" style={styles.newstyle}>
            <h5 style={{ marginRight: 20 }}> Print roll change now </h5>

            <Button
              onClick={() => {
                this.setState({ confirmModalVisible: true });
              }}
            >
              {"RESET"}
            </Button>
          </Row>
        ) : null}

        <Row
          className="border-bottom"
          style={{ backgroundColor: "whitesmoke" }}
        >
          <Col
            xs="12"
            style={{
              margin: 10,
              display: "flex",
              flex: 1,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h5 style={{ marginLeft: 10 }}>
              {" "}
              New: {this.state.newOrderCount}{" "}
            </h5>

           {this.state.canAutoPrintKot && (
            <h5>Auto Accept: {String(this.state.canAutoPrintKot)}</h5>
          )} 
            <h5 style={{ marginLeft: 10 }}>
              {" "}
              Ready: {this.state.readyOrderCount}{" "}
            </h5>
            <Button
              onClick={() => {
                console.log("soundPlayStatus", "pause");
                if (
                  (storeInformation.store &&
                    storeInformation.store.printSdkType &&
                    storeInformation.store.printSdkType === SDK_NGX_ASHWA) ||
                  (storeInformation.store &&
                    storeInformation.store.printSdkType &&
                    storeInformation.store.printSdkType ===
                      SDK_SUNMI_MINI_T1) ||
                  (storeInformation.store &&
                    storeInformation.store.printSdkType &&
                    storeInformation.store.printSdkType === SDK_SUNMI_PRO2)
                ) {
                  this.fromAndroid("stop");
                } else {
                  // if (player !== null) player.pause();
                  if (this.state.soundEnabled  && player !== null) player.pause();
                }
              }}
            >
               {this.state.soundEnabled ? 'Mute' : 'Start Sound Notification'}
              {/* {"  MUTE"} */}
            </Button>
          </Col>
        </Row>
        <Row
  xs="auto"
  style={{
    margin: 10,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  }}
>
  <Col>
    <Input
      style={{ height: 60, marginRight: 10, padding: 3, fontSize: 20 }}
      placeholder="Enter token id"
      type="number"
      onChange={this.handleTokenIdChange}
    />
    <Button
      color="primary"
      style={{ height: 60, padding: 3, fontSize: 20 }}
      onClick={() => {
        this.tokenSearch();
      }}
    >
      {"  Search Token"}
    </Button>
  </Col>
  <Col>
    <Input
      style={{ height: 60, marginRight: 10, padding: 3, fontSize: 20 }}
      placeholder="Enter Order Id"
      onChange={this.handleOrderIdChange}
    />
    <Button
      color="primary"
      style={{ height: 60, padding: 3, fontSize: 20 }}
      onClick={() => {
        this.orderIDSearch();
      }}
    >
      Search OrderID
    </Button>
  </Col>
</Row>


        <Modal
          size="lg"
          isOpen={this.state.tokenMissmatchModalVisible}
          toggle={this.toggleErrorTokenMissModal}
        >
          <ErrorTokenMiss
            editable={true}
            tokenErrorMessage={this.state.tokenErrorMessage}
            goBack={this.toggleErrorTokenMissModal}
          />
        </Modal>
        <Modal
          size="lg"
          isOpen={this.state.confirmModalVisible}
          toggle={this.toggleConfirmPrintRollModal}
        >
          <ConfirmPrintRoll
            editable={true}
            toggleStoreStatus={this.toggleStoreStatus}
            goBack={this.toggleConfirmPrintRollModal}
          />
        </Modal>
        <Modal
          size="lg"
          isOpen={this.state.orderModalVisible}
          toggle={this.toggleModal}
        >
          <DetailedOrderCard
            editable={true}
            order={this.state.popUpOrderDetails}
            toltalItemCount={null}
            goBack={this.toggleModal}
            pastOrder={false}
            bussiness={this.state.bussiness}
            storeInformation={this.state.storeInformation}
            refreshOrders={this.fetchOrders}
          />
        </Modal>
        <Modal
          size="lg"
          isOpen={this.state.qrCodeModalVisible}
          toggle={this.toggleQRCodeScannerModal}
        >
          <QRCodeScanner
            onResult={this.getOrderId}
            goBack={this.toggleQRCodeScannerModal}
          />
        </Modal>

        {this.state.isShowArrived === true
          ? this.viewFood()
          : this.viewAirport()}
      </Container>
    );
  }

  // Scanner QRCode
  getOrderId = async (val) => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let params = {};

    let loginMode = localStorage.getItem("loginMode");
    if (loginMode === "concessionaire") {
      this.props.history.push("/ordersummary");
    } else {
      if (loginMode === "store") {
        params = {
          storeId: storeInformation.store && storeInformation.store.id,
        };
      } else {
        params = {
          merchantId: storeInformation.merchant && storeInformation.merchant.id,
        };
      }
      if (
        storeInformation.store &&
        storeInformation.store.showArrived === true
      ) {
        let response = await requestManager.getResponseFromPredefinedQuery(
          "getOrders",
          params
        );

        if (response.error === null) {
          this.setState({
            orderData: response.data,
            orderHistory: response.data.orderHistory,
            newOrders: response.data.newOrders,
            acceptedOrders: response.data.acceptedOrders,
            approachingOrders: response.data.approachingOrders,
            arrivedOrders: response.data.arrivedOrders,
          });
          this.checkQrCode(val);
          try {
            this.notifiyNewOrdersUsingSoundAndNotification();
          } catch (e) {
            console.log(e);
          }
        } else {
          console.log("Connection to server failed.");
        }
      } else {
        let response = await requestManager.getResponseFromPredefinedQuery(
          "getKioskOrders",
          params
        );
        if (response.error === null) {
          let obj = {
            edges: [],
          };
          console.log("response", response.data);
          this.setState({
            orderData: response.data,
            orderHistory: response.data.orderHistory,
            newOrders: response.data.newOrders,
            acceptedOrders: response.data.acceptedOrders,
            approachingOrders: obj,
            arrivedOrders: obj,
          });
          this.checkQrCode(val);
          try {
            this.notifiyNewOrdersUsingSoundAndNotification();
          } catch (e) {
            console.log(e);
          }
        } else {
          console.log("Connection to server failed.");
        }
      }
    }
  };
  // Show Modal QRCODE if it is match
  checkQrCode(val) {
    console.log("val", val);

    // Check New Orders
    let check = false;
    for (let i = 0; i < this.state.newOrders.edges.length; i++) {
      if (this.state.newOrders.edges[i].node.orderId === val) {
        check = true;
        this.setState({
          orderModalVisible: true,
          popUpOrderDetails: this.state.newOrders.edges[i],
        });
        break;
      }
    }
    // Check Accept Orders
    console.log("acceptedOrders", JSON.stringify(this.state.acceptedOrders));
    if (check === false) {
      for (let i = 0; i < this.state.acceptedOrders.edges.length; i++) {
        console.log("orderId", this.state.acceptedOrders.edges[i].node.orderId);
        if (this.state.acceptedOrders.edges[i].node.orderId === val) {
          check = true;
          this.setState({
            orderModalVisible: true,
            popUpOrderDetails: this.state.acceptedOrders.edges[i],
          });
          break;
        }
      }
    }
    // Check Approaching Orders
    if (check === false) {
      for (let i = 0; i < this.state.approachingOrders.edges.length; i++) {
        console.log(
          "orderId",
          this.state.approachingOrders.edges[i].node.orderId
        );
        if (this.state.approachingOrders.edges[i].node.orderId === val) {
          check = true;
          this.setState({
            orderModalVisible: true,
            popUpOrderDetails: this.state.approachingOrders.edges[i],
          });
          break;
        }
      }
    }
    // Check Arrived Orders
    if (check === false) {
      for (let i = 0; i < this.state.arrivedOrders.edges.length; i++) {
        console.log("orderId", this.state.arrivedOrders.edges[i].node.orderId);
        if (this.state.arrivedOrders.edges[i].node.orderId === val) {
          check = true;
          this.setState({
            orderModalVisible: true,
            popUpOrderDetails: this.state.arrivedOrders.edges[i],
          });
          break;
        }
      }
    }
    // Check Order History
    if (check === false) {
      for (let i = 0; i < this.state.orderHistory.edges.length; i++) {
        console.log("orderId", this.state.orderHistory.edges[i].node.orderId);
        if (this.state.orderHistory.edges[i].node.orderId === val) {
          check = true;
          this.setState({
            orderModalVisible: true,
            popUpOrderDetails: this.state.orderHistory.edges[i],
          });
          break;
        }
      }
    }
    if (check === false) {
      alert("Token number is not matching.");
    }
  }

  getKOTDetails = async (id, orderID) => {

    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let authToken = storeInformation.token;

    let gngPrinterFontSize = localStorage.getItem("gngPrinterFontSize");

    let fontSize = 14;
    if (gngPrinterFontSize !== null) {
      fontSize = gngPrinterFontSize;
    }

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Token " + authToken);
    console.log(
      "params",
      JSON.stringify({
        checkout_id: id,
        font_size: fontSize,
        print_type: "KOT",
      })
    );
    // region_name
    try {
      var vtimestamp = generateEpochTimestamp();
      let response = await fetch(
        config.getHost() + "/product/get_invoice_details_html_string/",
        {
          method: "POST",
          headers: {
            Authorization: `Token ${authToken}`,
            "Content-Type": "application/json",
            Timestamp: vtimestamp,
            Signature: generateSignature(vtimestamp, authToken)             
          },
          body: JSON.stringify({
            checkout_id: id,
            font_size: fontSize,
            print_type: "KOT",
          }),
        }
      );

      console.log("KOT", response);

      if (response.status === 200) {
        let json = await response.json();
        let res = json.result;

        let kot = "";
        if (res && res.length > 0) {
          kot = `${res[0]}`;
        }
        console.log("KOT-fetchOrderDetailsAutoPrint", res);
        this.setState({ printKOTFun: kot });
        
        this.fetchOrderDetailsAutoPrint(id, orderID, kot);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  updateOrderStatus = (status, orderDetail, kot) => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    // print count and barcodegenrate
    let printCount = 0;
    if (
      storeInformation.store &&
      storeInformation.store.isPrintEnabled &&
      storeInformation.store.isPrintEnabled === true
    ) {
      if (status === "ACCEPTED") {
        // Print KOT on Accepted Status
        if (
          storeInformation.store.printSdkType === SDK_NGX_ASHWA ||
          storeInformation.store.printSdkType === SDK_SUNMI_PRO2 ||
          storeInformation.store.printSdkType === SDK_SUNMI_MINI_T1 ||
          storeInformation.store.printSdkType === SDK_NGX_NIX ||
          storeInformation.store.printSdkType === SDK_CHROME_ELECTRON
        ) {
          printCount = this.state.printRollCount;
          let order = orderDetail;
          let gngPrintersSelected = localStorage.getItem("gngPrintersSelected");

          let gngPrinterFontSize = localStorage.getItem("gngPrinterFontSize");

          let fontSize = 14;
          if (gngPrinterFontSize !== null) {
            fontSize = gngPrinterFontSize;
          }
          if (
            storeInformation.store &&
            storeInformation.store.barCodeGenerate === true
          ) {
            let obj = {
              BarCodeGenerate: "Y",
            };
            order.BarCodeGenerate = obj;

            order.DuplicatePrint = { DuplicatePrint: "N" };

            order.gngPrintersSelected = gngPrintersSelected;
          } else {
            let obj = {
              BarCodeGenerate: "N",
            };
            order.BarCodeGenerate = obj;
            order.DuplicatePrint = { DuplicatePrint: "N" };
            order.gngPrintersSelected = gngPrintersSelected;
          }

          if (
            storeInformation.store &&
            storeInformation.store.isPrintStoreName === true
          ) {
            order.isPrintStoreName = "Y";
          } else {
            order.isPrintStoreName = "N";
          }

          if (
            storeInformation.store &&
            storeInformation.store.isPrintRegionName === true
          ) {
            order.isPrintRegionName = "Y";
          } else {
            order.isPrintRegionName = "N";
          }

          if (
            storeInformation.store &&
            storeInformation.store.isPrintCustomerName === true
          ) {
            order.isPrintCustomerName = "Y";
          }

          if (
            storeInformation.store &&
            storeInformation.store.isPrintPickupPointName === true
          ) {
            order.isPrintPickupPointName = "Y";
          } else {
            order.isPrintPickupPointName = "N";
          }

          if (
            storeInformation.store &&
            storeInformation.store.isPrintCustomerPhoneNumber === true
          ) {
            order.isPrintCustomerPhoneNumber = "Y";
          } else {
            order.isPrintCustomerPhoneNumber = "N";
          }

          order.currentDate = moment().format("DD/MM/YYYY, h:mm a");
          order.fontSize = fontSize;
          order.printKOTFun = kot;

          // console.log(
          //   "gngPrintersSelected",
          //   JSON.stringify(gngPrintersSelected)
          // );
          // // this Console is important to print KOT Electron app
          // console.log(JSON.stringify({ gngprintText: order }));
          // Peri Print Rest
          // console.log('autoacceptprint-1')
          // this.printRest(kot)
          // console.log('autoacceptprint-2')

          // printed for Mumbai and Bangalore airport
          if (
            (storeInformation.store &&
              storeInformation.store.printSdkType === SDK_NGX_ASHWA) ||
            storeInformation.store.printSdkType === SDK_SUNMI_PRO2 ||
            storeInformation.store.printSdkType === SDK_SUNMI_MINI_T1
          ) {
            this.fromAndroid(order);
          }

          if (
            storeInformation.store.isMultiplePrintEnabled &&
            storeInformation.store.isMultiplePrintEnabled === true
          ) {
            let printedOrders = localStorage.getItem("printedOrders");
            let print = JSON.parse(printedOrders);
            localStorage.setItem(
              "printedOrders",
              JSON.stringify({
                orders: print.orders.concat(orderDetail.node.orderId),
              })
            );
          }
        }
      }
    }
    if (status === "DELIVERED" || status === "DISPATCHED") {
      let storageData = localStorage.getItem("attendedOrders");
      let attendedOrders;
      if (storageData === null) {
        attendedOrders = {
          newOrders: [],
          arrivedOrders: [],
          approachingOrders: [],
        };
      } else {
        attendedOrders = JSON.parse(storageData);
      }

      let check = false;

      for (let i = 0; i < attendedOrders.newOrders.length; i++) {
        if (attendedOrders.newOrders[i] === orderDetail.node.orderId) {
          console.log("attendedOrders removed", attendedOrders.newOrders[i]);
          attendedOrders.newOrders.splice(i, 1);
          check = true;
          break;
        }
      }

      if (check === true) {
        localStorage.setItem(
          "attendedOrders",
          JSON.stringify({
            newOrders: attendedOrders.newOrders,
            approachingOrders: attendedOrders.approachingOrders,
            arrivedOrders: attendedOrders.arrivedOrders,
          })
        );
      }
    }
    console.log('autoacceptprint-3')
     orderStatusManager.updateOrderStatus(
      orderDetail.node.id,
      status,
      printCount
    );
    console.log('autoacceptprint-4')

  };

  viewAirport() {
    return (
      <Row>
        <Col
          md="3"
          d="flex"
          flex="column"
          align-items="stretch"
          style={{ backgroundColor: "white" }}
        >
          <p className="text-center p-2 font-weight-bold">New Orders</p>
          {this.state.newOrders &&
            this.state.newOrders.edges.map((order) => {
              return (
                <OrderCard
                  order={order}
                  key={order.node.id}
                  refreshOrders={this.fetchOrders}
                  cardSelected={this.cardSelected}
                  bussiness={this.state.bussiness}
                  storeInformation={this.state.storeInformation}
                />
              );
            })}
        </Col>

        <Col d="flex" style={{ backgroundColor: "whitesmoke" }}>
          <p className="text-center p-2 font-weight-bold">Under Preparation</p>
          <Row noGutters>
            {this.state.acceptedOrders &&
              this.state.acceptedOrders.edges.map((order) => {
                return (
                  <OrderCard
                    order={order}
                    key={order.node.id}
                    refreshOrders={this.fetchOrders}
                    printRollChange={this.getPrintRollChange}
                    cardSelected={this.cardSelected}
                    bussiness={this.state.bussiness}
                    storeInformation={this.state.storeInformation}
                  />
                );
              })}
          </Row>
        </Col>
      </Row>
    );
  }
  viewFood() {
    return (
      <Row noGutters>
        <Col
          sm="12"
          md="3"
          d="flex"
          flex="column"
          align-items="stretch"
          style={{ backgroundColor: "whitesmoke" }}
        >
          <p className="text-center p-2 font-weight-bold">New Orders</p>
          {this.state.newOrders &&
            this.state.newOrders.edges.map((order) => {
              return (
                <OrderCard
                  order={order}
                  key={order.node.id}
                  refreshOrders={this.fetchOrders}
                  printRollChange={this.getPrintRollChange}
                  cardSelected={this.cardSelected}
                  bussiness={this.state.bussiness}
                  storeInformation={this.state.storeInformation}
                />
              );
            })}
        </Col>

        <Col sm="12" md="3" style={{ backgroundColor: "white" }}>
          <p className="text-center p-2 font-weight-bold">Under Preparation</p>
          {this.state.acceptedOrders &&
            this.state.acceptedOrders.edges.map((order) => {
              return (
                <OrderCard
                  order={order}
                  key={order.node.id}
                  refreshOrders={this.fetchOrders}
                  printRollChange={this.getPrintRollChange}
                  cardSelected={this.cardSelected}
                  bussiness={this.state.bussiness}
                  storeInformation={this.state.storeInformation}
                />
              );
            })}
        </Col>

        <Col sm="12" md="3" style={{ backgroundColor: "whitesmoke" }}>
          <p className="text-center p-2 font-weight-bold">
            Approaching Customers
          </p>
          {this.state.approachingOrders &&
            this.state.approachingOrders.edges.map((order) => {
              console.log(order);
              return (
                <OrderCard
                  order={order}
                  key={order.node.id}
                  refreshOrders={this.fetchOrders}
                  cardSelected={this.cardSelected}
                  printRollChange={this.getPrintRollChange}
                  bussiness={this.state.bussiness}
                  storeInformation={this.state.storeInformation}
                />
              );
            })}
        </Col>

        <Col sm="12" md="3" style={{ backgroundColor: "white" }}>
          <p className="text-center p-2 font-weight-bold">Arrived Customers</p>
          {this.state.arrivedOrders &&
            this.state.arrivedOrders.edges.map((order) => {
              return (
                <OrderCard
                  order={order}
                  key={order.node.id}
                  refreshOrders={this.fetchOrders}
                  cardSelected={this.cardSelected}
                  bussiness={this.state.bussiness}
                  printRollChange={this.getPrintRollChange}
                  storeInformation={this.state.storeInformation}
                />
              );
            })}
        </Col>
      </Row>
    );
  }
}

// if (

//   newSoundOrders.length > 0
//   // approachingSoundOrders.length > 0 ||
//   // arrivedSoundOrders.length > 0
// ) {
//   // this.setState({ soundPlayStatus: Sound.status.PAUSED });

//   // this.playSoundInterval = setInterval(() => {

//   // }, 1000);
//   // this.playSound();
//   // localStorage.setItem(
//   //   "attendedOrders",
//   //   JSON.stringify({
//   //     newOrders: attendedOrders.newOrders.concat(newSoundOrders),
//   //     approachingOrders: attendedOrders.approachingOrders.concat(
//   //       approachingSoundOrders
//   //     ),
//   //     arrivedOrders: attendedOrders.arrivedOrders.concat(arrivedSoundOrders)
//   //   })
//   // );
// }

// newSoundOrders.forEach(order => {
//   let orderDetails = this.state.newOrders.edges.find(orderDetails => {
//     return (orderDetails.node.id = order);
//   });
//    if ("Notifcation" in window) {
//     if (Notification.permission === "granted") {
//       new Notification(
//         `New Order! Token number:${orderDetails.node.storeToken}`,
//         {
//           body:
//             "A new order has been received at your store. Please accept it.",
//           icon: require("../../assets/img/brand/highlighted-logo.png")
//         }
//       );
//     }
//    }
// });

// arrivedSoundOrders.forEach(order => {
//   let orderDetails = this.state.arrivedOrders.edges.find(orderDetails => {
//     return (orderDetails.node.id = order);
//   });
//   if ("Notification" in window) {
//     if (Notification.permission === "granted") {
//       new Notification(
//         `Customer Arrived! Token number:${orderDetails.node.storeToken}`,
//         {
//           body:
//             "Customer has arrived at your store. Please step out and deliver order.",
//           icon: require("../../assets/img/brand/highlighted-logo.png")
//         }
//       );
//     }
//   }
// });



// WEBPACK FOOTER //
// ./src/pages/ActiveOrders/ActiveOrders.js